// extracted by mini-css-extract-plugin
module.exports = {"mainStructure__body":"main-structure_mainStructure__body__KfyHQ","mainStructure__container":"main-structure_mainStructure__container__gitD_"};